import React from 'react';
import cn from 'classnames';
import { ReactComponent as InCallIcon } from '../../../../resource/InCallIcon.svg';
import { ReactComponent as OutCallIcon } from '../../../../resource/OutCallIcon.svg';
import styles from './CallDirection.module.scss';

const CallDirection = ({ direction }) => {
  const inCall = direction === 'in';
  const outCall = direction === 'out' || direction === 'callback';

  return (
    <div
      className={cn(styles.root, {
        [styles.inCall]: inCall,
        [styles.outCall]: outCall,
      })}
    >
      {inCall && <InCallIcon className={styles.icon} />}
      {outCall && <OutCallIcon className={styles.icon} />}
    </div>
  );
};

export default CallDirection;
